import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";

const SubjectCard = ({ image, title, description }) => {
  return (
    <Box
      sx={{
        Width: "100%",
        textAlign: "center",
        borderRadius: 4,
        margin: "auto",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <img src={image} alt={title} width="400" />
      </Box>
      <CardContent>
        <Typography
          variant="h5"
          component="div"
          sx={{ fontWeight: "bold", color: "#1976d2" }}
        >
          {title} 
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ textAlign:"justify", }} mt={2}>
          {description}
        </Typography>
      </CardContent>
    </Box>
  );
};

export default SubjectCard;
